import { db } from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'
import firebase from 'firebase/app'

// Extend EventEmitter so user of DoctorRepository can react to our own defined events. (ex: doctorRepository.on('added'))
class DoctorRepository extends EventEmitter {
    setKey (key) {
        if (this.key)
            return this

        this.key = key
        this.doc = db.collection('doctors').doc(this.key)

        this.subscribe()

        return this
    }

    async uncertifiedIds () {
        const results = []
        const querySnapshot = await db.collection('doctors').where('isCertified', '==', false).get()

        querySnapshot.forEach((doc) => {
            results.push(doc.id)
        })

        return results
    }

    all (onSuccess, onError) {
        db.collection('doctors')
            .get()
            .then((querySnapshot) => {
                let doctors = []

                querySnapshot.forEach((doc) => {
                    let doctor = doc.data()
                    doctor.offices = {}

                    db.collection('offices')
                        .where('doctorId', '==', doc.id)
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach((doc) => {
                                doctor.offices[doc.id] = doc.data()
                            })

                            doctors.push(doctor)
                        })
                });

                onSuccess(doctors)
            })
            .catch((error) => {
                onError(error)
            })
    }

    allWithoutOffices (onSuccess, onError) {
        db.collection('doctors')
            .get()
            .then((querySnapshot) => {
                let doctors = []

                querySnapshot.forEach((doc) => {
                    doctors.push(doc.data())
                });

                onSuccess(doctors)
            })
            .catch((error) => {
                onError(error)
            })
    }

    onlyCertified(isCertified, onSuccess, onError) {
        db.collection('doctors')
            .where('isCertified', '==', isCertified == 1 || isCertified == '1' ? true : false)
            .get()
            .then((querySnapshot) => {
                let doctors = []

                querySnapshot.forEach((doc) => {
                    let doctor = doc.data()
                    doctor.offices = {}

                    db.collection('offices')
                        .where('doctorId', '==', doc.id)
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach((doc) => {
                                doctor.offices[doc.id] = doc.data()
                            })

                            doctors.push(doctor)
                        })
                });

                onSuccess(doctors)
            })
            .catch((error) => {
                onError(error)
            })
    }

    // Retrieve a doctor
    async find (id) {
        const snapshot = await this.setKey(id).doc.get();

        if (snapshot.exists) {
            return snapshot.data()
        }

        return null
    }

    // Retrieve all uncertified doctors IDs
    async getUncertifiedIds () {
        const querySnapshot = await db.collection('doctors')
            .where('isCertified', '==', false)
            .get()

        const ids = []

        querySnapshot.forEach(doc => ids.push(doc.id))

        return ids
    }

    // Check if a Doctor exists
    load (userId, onSuccess, onError) {
        this.setKey(userId)
            .doc
            .get()
            .then((snapshot) => {
                if (snapshot.exists) {
                    onSuccess(snapshot.data())
                } else {
                    onError()
                }
            })
    }

    // Update a Doctor
    async update (id, data, onComplete, onError) {
        let batch = db.batch()

        let doctorRef = db.collection('doctors').doc(id)
        batch.update(doctorRef, data)

        const officeData = {}

        if (data.hasOwnProperty('firstName')) {
            officeData['doctorFirstName'] = data.firstName
        }
        if (data.hasOwnProperty('lastName')) {
            officeData['doctorLastName'] = data.lastName
        }
        if (data.hasOwnProperty('type')) {
            officeData['doctorType'] = data.type
        }
        if (data.hasOwnProperty('avatar')) {
            officeData['doctorAvatar'] = data.avatar
        }
        if (data.hasOwnProperty('isRegulated')) {
            officeData['isDoctorRegulated'] = data.isRegulated
        }

        if (Object.keys(officeData).length > 0) {
            await db.collection('offices')
                .where('doctorId', '==', id)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach((doc) => {
                        let office = doc.data()
                        let ref = db.collection('offices').doc(office.id)

                        let newData = {
                            ...office,
                            ...officeData
                        }

                        if (!newData.schedule) {
                            newData['schedule'] = []
                        }

                        batch.update(ref, newData)
                    })
                })
                .catch(onError)
        }

        batch.commit().then(onComplete).catch(onError)
    }

    // Remove a Doctor
    remove (onComplete) {
        this.doc.remove(onComplete)
    }

    // Check if a Doctor exists
    exists (onSuccess, onError) {
        this.doc.get().then((snapshot) => {
            if (snapshot.exists) {
                onSuccess(snapshot.data())
            } else {
                onError()
            }
        })
    }

    // Attach listeners to Firebase
    subscribe () {
        this.doc.onSnapshot( (doc) => {
            this.onChanged(doc)
        })
    }

    // Detach listeners to Firebase
    unsubscribe () {
        console.log('unsubscribed DoctorRepository')
        this.doc.onSnapshot( () => {})
    }

    onChanged (snapshot) {
        this.emit('changed', snapshot.id, snapshot.exists ? snapshot.data() : null)
    }
}

export default new DoctorRepository()



// WEBPACK FOOTER //
// ./src/data/DoctorRepository.js